(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cabo-flex-personalization"] && !Shopify.designMode) return;
  try {
    function setupCaboFlexPersonalization() {
    document.querySelectorAll('[data-cabo-flex-text]').forEach((input) => {
      const form = input.form;
      if (!form || form.dataset.caboFlexReady) return;
      form.addEventListener('submit', (event) => {
        input.setCustomValidity(input.value.trim() ? '' : 'Bitte Motiv oder Text und die gewünschte Druckfarbe eintragen.');
        if (!input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        }
      }, true);
      input.addEventListener('input', () => input.setCustomValidity(''));
      form.dataset.caboFlexReady = 'true';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCaboFlexPersonalization);
  } else {
    setupCaboFlexPersonalization();
  }
  document.addEventListener('shopify:section:load', setupCaboFlexPersonalization);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cabo-hoodie-personalization"] && !Shopify.designMode) return;
  try {
    function setupCaboHoodiePrint() {
    document.querySelectorAll('[data-cabo-hoodie-print]').forEach((root) => {
      if (root.dataset.ready) return;
      const scope = root.closest('product-info') || root.closest('section');
      const details = root.querySelector('[data-cabo-hoodie-details]');
      const input = root.querySelector('textarea');
      const form = input.form;
      if (!scope || !form) return;
      const sync = () => {
        const choices = scope.querySelectorAll('variant-selects select');
        const choice = scope.querySelector('select[name="options[Druck]"]') || choices[2];
        if (!choice) return;
        const printed = choice.selectedOptions[0]?.textContent.trim() !== 'Ohne Druck';
        details.hidden = !printed;
        input.disabled = !printed;
        input.required = printed;
        input.setCustomValidity('');
      };
      scope.addEventListener('change', sync);
      new MutationObserver(sync).observe(scope, { childList:true, subtree:true });
      form.addEventListener('submit', (event) => {
        sync();
        input.setCustomValidity(!input.disabled && !input.value.trim() ? 'Bitte den Druckwunsch und die Position angeben.' : '');
        if (!input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        }
      }, true);
      input.addEventListener('input', () => input.setCustomValidity(''));
      root.dataset.ready = 'true';
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCaboHoodiePrint);
  else setupCaboHoodiePrint();
  document.addEventListener('shopify:section:load', setupCaboHoodiePrint);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cabo-textile-quote-form"] && !Shopify.designMode) return;
  try {
    function setupCaboTextileQuotes() {
    document.querySelectorAll('.cabo-textile-quote').forEach((root) => {
      if (root.dataset.initialized) return;
      const data = root.querySelector('[data-textile-variants]');
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const selects = Array.from(root.querySelectorAll('[data-textile-option]'));
      const update = () => {
        const values = selects.map((select) => select.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));
        if (!variant) return;
        root.querySelector('[data-textile-sku]').value = variant.sku;
        root.querySelector('[data-textile-variant]').value = String(variant.id);
        root.querySelector('[data-textile-choice]').textContent = values.join(' · ');
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        const gallery = document.getElementById('MediaGallery-' + root.dataset.sectionId);
        if (variant.mediaId && gallery && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(root.dataset.sectionId + '-' + variant.mediaId, true);
        }
      };
      selects.forEach((select) => select.addEventListener('change', update));
      root.dataset.initialized = 'true';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCaboTextileQuotes);
  } else {
    setupCaboTextileQuotes();
  }
  document.addEventListener('shopify:section:load', setupCaboTextileQuotes);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cabo-uv-personalization"] && !Shopify.designMode) return;
  try {
    function setupCaboUVPersonalization() {
    document.querySelectorAll('[data-cabo-uv-text]').forEach((input) => {
      const form = input.form;
      if (!form || form.dataset.caboUvReady) return;
      form.addEventListener('submit', (event) => {
        input.setCustomValidity(input.value.trim() ? '' : 'Bitte einen Namen oder Druckwunsch eintragen.');
        if (!input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        }
      }, true);
      input.addEventListener('input', () => input.setCustomValidity(''));
      form.dataset.caboUvReady = 'true';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCaboUVPersonalization);
  } else {
    setupCaboUVPersonalization();
  }
  document.addEventListener('shopify:section:load', setupCaboUVPersonalization);
  } catch(e) { console.error(e); }
})();

})();
